import React, { useState } from 'react';
import { T } from './translations';

const C = {
  orange: '#F59420',
  white: '#ffffff',
  off: '#f8f9fa',
  border: '#e5e7eb',
  textDark: '#111827',
  muted: '#6b7280',
  r: '8px',
};

const IconWA = ({ size = 26 }) => (
  <svg width={size} height={size} viewBox="0 0 26 26" fill="white" aria-label="WhatsApp" role="img">
    <path d="M13 .5C6.1.5.5 6.1.5 13c0 2.3.6 4.5 1.7 6.4L.5 25.5l6.3-2c1.8 1 3.8 1.5 6.2 1.5C19.9 25 25.5 19.4 25.5 12.5 25.5 5.6 19.9.5 13 .5zm0 22.5c-1.9 0-3.8-.5-5.4-1.4l-.4-.2-4 1.2 1.2-4-.3-.4C3.2 16.5 2.7 14.8 2.7 12.9 2.7 7.3 7.4 2.7 13 2.7c5.6 0 10.3 4.6 10.3 10.3 0 5.7-4.7 10-10.3 10zm5.7-7.7c-.3-.2-1.8-.9-2-.9-.3-.1-.5-.1-.7.2-.2.3-.7.9-.9 1.1-.2.2-.3.2-.6.1-.3-.2-1.2-.5-2.3-1.5-.9-.8-1.5-1.8-1.6-2-.2-.3 0-.5.1-.6.1-.2.3-.4.4-.5.1-.2.2-.3.2-.5 0-.2-.6-1.5-.8-2-.2-.5-.5-.4-.7-.4h-.6c-.2 0-.5.1-.7.4-.3.3-1 1-1 2.4s1 2.8 1.2 3.1c.2.2 2 3.1 4.8 4.3.7.3 1.2.5 1.6.6.7.2 1.3.2 1.8.1.6-.1 1.7-.7 1.9-1.4.2-.7.2-1.2.1-1.3-.1-.1-.3-.2-.6-.4z" />
  </svg>
);

export default function FaqPage({ lang }) {
  const [openFaq, setOpenFaq] = useState(null);
  const t = T[lang];
  const faqs = [1, 2, 3, 4, 5, 6, 7, 8].map(i => ({ q: t[`faq_q${i}`], a: t[`faq_a${i}`] }));

  return (
    <section className="section-pad" style={{ padding: '88px 48px', background: C.white }}>
      <div style={{ maxWidth: 760, margin: '0 auto' }}>
        <div style={{ fontSize: 11, letterSpacing: 2.5, textTransform: 'uppercase', color: C.orange, fontWeight: 700, marginBottom: 10 }}>
          {t.faq_eyebrow}
        </div>
        <h2 className="section-h2" style={{
          fontSize: 40, fontWeight: 800, color: C.textDark,
          letterSpacing: -1.2, lineHeight: 1.15, marginBottom: 48,
        }}>
          {t.faq_h2}
        </h2>

        <div>
          {faqs.map((item, i) => (
            <div key={i} style={{ borderBottom: `1px solid ${C.border}` }}>
              <button
                onClick={() => setOpenFaq(openFaq === i ? null : i)}
                style={{
                  width: '100%', textAlign: 'left', padding: '20px 0',
                  background: 'none', border: 'none', cursor: 'pointer',
                  display: 'flex', justifyContent: 'space-between', alignItems: 'center',
                  fontSize: 16, fontWeight: 600, color: openFaq === i ? C.orange : C.textDark,
                  transition: 'color 0.2s',
                }}
                aria-expanded={openFaq === i}
              >
                <span>{item.q}</span>
                <span style={{
                  color: C.orange, fontSize: 22, lineHeight: 1,
                  flexShrink: 0, marginLeft: 16, fontWeight: 300,
                  transition: 'transform 0.2s',
                  transform: openFaq === i ? 'rotate(45deg)' : 'none',
                  display: 'inline-block',
                }}>+</span>
              </button>
              {openFaq === i && (
                <p style={{ fontSize: 15, color: C.muted, lineHeight: 1.75, paddingBottom: 24, paddingRight: 32 }}>
                  {item.a}
                </p>
              )}
            </div>
          ))}
        </div>

        <div style={{
          marginTop: 36, padding: '20px 24px', background: C.off,
          borderRadius: C.r, border: `1px solid ${C.border}`,
          display: 'flex', alignItems: 'center', justifyContent: 'space-between', flexWrap: 'wrap', gap: 12,
        }}>
          <p style={{ fontSize: 14, color: C.muted }}>{t.faq_wa_cta}</p>
          <a href="https://wa.me/573059469665" target="_blank" rel="noopener noreferrer" style={{
            display: 'inline-flex', alignItems: 'center', gap: 8,
            background: '#25D366', color: C.white, padding: '10px 18px',
            borderRadius: C.r, fontWeight: 700, fontSize: 14, textDecoration: 'none',
          }}>
            <IconWA size={18} />{t.faq_wa_link}
          </a>
        </div>
      </div>
    </section>
  );
}
